import React, { useState, useEffect } from "react";

import FooterSection from "../../component/footerSection";
import HeaderSection from "../../component/headerSection";
import BannerSection from "../../component/bannerSection";
import FeaturesSection from "../../component/featuresSection";
import AboutSection from "../../component/aboutSection";
import WorkesSection from "../../component/workesSection";
import FaqSection from "../../component/faqSection";
import BeautifullInterfaceSection from "../../component/beautifullInterfaceSection";
import DownloadSection from "../../component/downloadSection";

import BeautifullUiDesign from "../../component/beautifulUiSection";
import { MainPageStyle } from "./style";

const MainPage = () => {


  return (
    <MainPageStyle>
        <HeaderSection />
        <BannerSection />
        <FeaturesSection />
        <AboutSection />
        <BeautifullUiDesign />
        <WorkesSection />
        <FaqSection />
        <BeautifullInterfaceSection />
        <DownloadSection />
        <FooterSection />
    </MainPageStyle>
  );
};

export default MainPage;
